'use client';

import React, { useState } from 'react';
import { intelligenceReports } from './intelligenceData';
import ReportCard from './ReportCard';
import { toast } from 'sonner';

export default function IntelligenceReportGrid() {
  const [reports, setReports] = useState(intelligenceReports);

  const handleSaveToggle = (reportId: string) => {
    setReports((prev) =>
      prev.map((r) => {
        if (r.id === reportId) {
          const next = !r.isSaved;
          toast[next ? 'success' : 'info'](
            next ? 'Report saved to your Intelligence Desk' : 'Report removed from saved',
            { description: r.title }
          );
          return { ...r, isSaved: next };
        }
        return r;
      })
    );
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-2 2xl:grid-cols-2 gap-5">
      {reports.map((report) => (
        <ReportCard
          key={report.id}
          report={report}
          onSaveToggle={handleSaveToggle}
        />
      ))}
    </div>
  );
}